import {
    REQUEST_STOCK_TAKING,
    RECEIVE_STOCK_TAKING,
    ERROR_STOCK_TAKING
} from '../types'
import {fetchUrl} from '../../constants/constants'
import fetchErrorCtrl from "../../helpers/fetchErrorCtrl"
import shouldFetch from "../../helpers/shouldFetch"
import axios from 'axios'

function request() {
    return {
        type: REQUEST_STOCK_TAKING
    };
}

export function receive(data) {
    return {
        type: RECEIVE_STOCK_TAKING,
        payload: data
    }
}

function failed(data) {
    return {
        type: ERROR_STOCK_TAKING,
        errors: data
    }
}

export function getStockTaking(data = {}, force = false) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().cashflow, !force)) {
            dispatch(request())
            return axios({
                method: 'POST',
                url: fetchUrl + 'stock-taking',
                data
            }).then(res => {
                dispatch(receive(res.data.data))
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failed(errors))
            })
        } else {
            return Promise.resolve()
        }
    }
}
